/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Turn_SrInputs */

const en_your_turn_sr = /** @type {(inputs: Your_Turn_SrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`waiting on you`)
};

/**
* | output |
* | --- |
* | "waiting on you" |
*
* @param {Your_Turn_SrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const your_turn_sr = /** @type {((inputs?: Your_Turn_SrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Turn_SrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_your_turn_sr(inputs)
});